import { useAuthStore } from '@/stores/auth.store';
import { Access, Permission, canAccess, roleHasPermission } from '@/lib/permissions';

export function usePermissions() {
    const role = useAuthStore((state) => state.user?.role);
    return {
        role,
        isLoaded: role !== undefined,
        isAdmin: role === 'admin',
        can: (permission: Permission) => roleHasPermission(role, permission),
        canAccess: (access: Access) => canAccess(role, access),
    };
}
